<div class="bell-wrapper position-relative">

  <!-- ── Botón Bell ─────────────────────────────────────────── -->
  <button class="btn btn-bell" (click)="toggleDropdown($event)" aria-label="Mensajes">
    <i class="bi bi-bell-fill fs-5"></i>
    @if ((unreadCount$ | async)! > 0) {
      <span class="bell-badge">
        {{ (unreadCount$ | async)! > 99 ? '99+' : (unreadCount$ | async) }}
      </span>
    }
  </button>

  <!-- ── Dropdown ───────────────────────────────────────────── -->
  @if (isOpen) {
    <div class="bell-dropdown" (click)="$event.stopPropagation()">

      <!-- Header -->
      <div class="bell-header">
        <span class="fw-semibold small">Mensajes</span>
        @if ((unreadCount$ | async)! > 0) {
          <button class="btn btn-link btn-sm p-0 text-muted small" (click)="markAllRead($event)">
            Marcar todo
          </button>
        }
      </div>

      <!-- Body -->
      @if (loading$ | async) {
        <div class="bell-loading">
          <span class="spinner-border spinner-border-sm text-secondary"></span>
        </div>
      } @else if ((messages$ | async)?.length === 0) {
        <div class="bell-empty">
          <i class="bi bi-inbox fs-3 d-block mb-1 opacity-50"></i>
          Sin mensajes nuevos
        </div>
      } @else {
        <div class="bell-list">
          @for (msg of (messages$ | async); track trackById($index, msg)) {
            <div class="bell-item" [class.unread]="!msg.isRead" (click)="openMessage(msg, $event)">
              <div class="d-flex gap-2 align-items-start">
                <div class="flex-grow-1 overflow-hidden">
                  <div class="client-name text-truncate">
                    {{ msg.transactionRef.client.firstName }} {{ msg.transactionRef.client.lastName }}
                  </div>
                  <span [class]="badgeClass(msg.action)" style="font-size: 0.65rem;">{{ label(msg) }}</span>
                  @if (msg.note) {
                    <div class="note-text text-truncate mt-1">{{ msg.note }}</div>
                  }
                </div>
                <div class="msg-time">{{ timeAgo(msg.createdAt) }}</div>
              </div>
            </div>
          }
        </div>
      }

      <!-- Footer -->
      <div class="bell-footer">
        <a routerLink="/seller/messages" (click)="closeDropdown()" class="small">
          Ver todos los mensajes
        </a>
      </div>

    </div>
  }

</div>
